import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders,HttpParams}from '@angular/common/http';
import {DisplayFormComponent} from '../components/display-form/display-form.component';
import { LayoutDto } from '../models/layout';
import { from } from 'rxjs';
import { AppGlobals } from '../app.global';
import { DetailDto } from '../models/Detail';
import { SummaryDto } from '../models/Summary';
import { SaveDataDto } from '../models/SaveData';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {

  static urlport: any;

  constructor(private httpClient:HttpClient,private appGlobals:AppGlobals ) { 
    
  }


  GetLayoutData(username: string, mode: string, plants: string, factory: string,valueStream:string,startDate:string,endDate:string, SO:string,lineItem:string,cust:string, FG:string, mattype:string,RM:string, matGrp:string,purgrp:string, PO:string,colour:string,stoLocation:string,style:string) {
    var url: string = this.appGlobals.baseAPIUrl + 'GetLayout';
    return this.httpClient.get<LayoutDto[]>(url + "?uname=" + username + "&mode=" + mode + "&plant=" + plants + "&factory=" + factory+ "&valueStream=" + valueStream+ "&fromDate=" + startDate+ "&toDate=" + endDate+"&SO="+SO+"&lineItem="+lineItem+"&cust="+cust+"&FG="+FG+"&mattype=" + mattype+"&RM="+RM+"&matGrp="+matGrp+"&purgrp="+purgrp+"&PO="+PO + "&colour="+colour + "&stoLocation="+stoLocation + "&style="+style);
  };

  GetDetailList(tokenID:string)
  {
    var url: string = this.appGlobals.baseAPIUrl + 'GetDetailList';
    return this.httpClient.get<DetailDto[]>(url + "?tokenID=" + tokenID);
  };

  GetSummaryList(tokenID:string)
  {
    var url: string = this.appGlobals.baseAPIUrl + 'GetSummaryList';
    return this.httpClient.get<SummaryDto[]>(url + "?tokenID=" + tokenID);
  };

  GetRedButtonSummaryDetailReport(tokenID:string,date:string,workcenter:string,mode:string)
  {
    var url: string = this.appGlobals.baseAPIUrl + 'RedButtonSummaryDetailReport';
    return this.httpClient.get(url + "?tokenID=" + tokenID+ "&date=" + date + "&workcenter=" + workcenter +"&mode=" +mode);
  };

  SaveDetails(mandt:string, werks:string, start_date:string, arbpl:string, rmmatnr:string, j_3asize:string, vbeln:string, posnr:string, aufnr:string, lgort:string, charg:string, mvd_comment:string,mvd_comment_user:string)
  {    
    var url=this.appGlobals.baseAPIUrl + 'SaveDetails';

    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
   return this.httpClient.post(url,
   {
       "mandt": mandt,
       "werks": werks,
       "start_date": start_date,
       "arbpl": arbpl,
       "rmmatnr": rmmatnr,
       "j_3asize": j_3asize,
       "vbeln": vbeln,
       "posnr": posnr,
       "aufnr": aufnr,
       "lgort": lgort,
       "charg": charg,
       "mvd_comment": mvd_comment,
       "mvd_comment_user":mvd_comment_user
   },{headers});
  //  .subscribe(
  //      data => {
  //          console.log("POST Request is successful ", data);
  //          if(data!=null)
  //          {
             
  //          }
           
  //          //return data;
  //      },
  //      error => {
  //          console.log("Error", error);
  //      }
  //  );
  };

  SaveAllDetails(selectedLineItems:any[])
  {    
    var url=this.appGlobals.baseAPIUrl + 'SaveAllDetails';

  return this.httpClient.post<any[]>(url,selectedLineItems);
  }

  GetPlant()
  {
    var url: string = this.appGlobals.baseAPIUrl + 'GetPlant';
    return this.httpClient.get<DetailDto[]>(url);
  };
}
